import type { ArticleHeading } from './types'

export const DEFAULT_TOC_LABEL = 'Table of contents'
export const DEFAULT_SHARE_LABEL = 'Share'
export const DEFAULT_SHARE_ON_X_LABEL = 'Share on X'
export const DEFAULT_SHARE_ON_LINKEDIN_LABEL = 'Share on LinkedIn'

export const DEFAULT_STICKY_TOP_OFFSET = 96
// Breathing room between the fixed chrome and both the stuck sidebar and a
// heading scrolled to, so the card top and the heading line up.
export const ARTICLE_STICKY_GAP = 24

export const ARTICLE_SIDEBAR_WIDTH = 340
export const ARTICLE_COLUMN_GAP = 72

// The website's rem ladder (apps/website/renderer/style.css). Its variables are
// not part of @slite/style, so every size here carries the value as fallback and
// the component renders the same in Storybook and on the site.
export const fontSize = {
  title: 'var(--font-size-1, 2.8rem)',
  lead: 'var(--font-size-5, 1.1rem)',
  body: 'var(--font-size-6, 1rem)',
  small: 'var(--font-size-7, 0.85rem)',
  tiny: 'var(--font-size-8, 0.75rem)',
} as const

// Matches `mediaQueryMedium` in the website app, so the article collapses at the
// same width as the rest of the site.
export const ARTICLE_SIDEBAR_BREAKPOINT = '@media screen and (max-width: 68rem)'

export function youtubeEmbedUrl(videoId: string) {
  return `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&cc_load_policy=0`
}

export function twitterShareUrl(text: string, url: string) {
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`
}

export function linkedInShareUrl(url: string) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
}

export function articleHeadingsKey(headings: readonly ArticleHeading[]) {
  return headings.map((h) => `${h.level}:${h.id}:${h.title}`).join('|')
}
